/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export const $RateSheetGeneratorIndexResponse = {
    properties: {
        rateSheetGeneratorId: {
            type: 'number',
            isRequired: true,
        },
        label: {
            type: 'string',
            isRequired: true,
        },
        isActive: {
            type: 'number',
            isRequired: true,
        },
        subscriptionId: {
            type: 'number',
            isRequired: true,
        },
        isIddd: {
            type: 'number',
            isRequired: true,
        },
        isNanp: {
            type: 'number',
            isRequired: true,
        },
        omitIsos: {
            properties: {
            },
            isRequired: true,
        },
        onlyIsos: {
            properties: {
            },
            isRequired: true,
        },
        marginPercent: {
            type: 'number',
            isRequired: true,
        },
        marginMinimum: {
            type: 'number',
            isRequired: true,
        },
        vendorRateMin: {
            properties: {
            },
            isRequired: true,
        },
        vendorRateMax: {
            properties: {
            },
            isRequired: true,
        },
        vendorCoverMin: {
            type: 'number',
            isRequired: true,
        },
        vendorDepthMax: {
            type: 'number',
            isRequired: true,
        },
        rateMultipliers: {
            type: 'Array',
            isRequired: true,
        },
        roundingPrecision: {
            type: 'number',
            isRequired: true,
        },
        routingOptions: {
            type: 'RsgRoutingOptions',
            isRequired: true,
        },
        rsgFileNameFmt: {
            properties: {
            },
            isRequired: true,
        },
        rsgFilePfx: {
            properties: {
            },
            isRequired: true,
        },
        rsgFileSfx: {
            properties: {
            },
            isRequired: true,
        },
        createdTs: {
            type: 'Date',
            isRequired: true,
            format: 'date-time',
        },
        updatedTs: {
            properties: {
            },
            isRequired: true,
        },
    },
};